export default "__VITE_ASSET__COi7FUps__"